export const collectQuantityConversionPayloadMap = (fields = []) => {
  const conversionMap = {};

  const collect = currentFields => {
    currentFields.forEach(field => {
      if (field?.child?.length) {
        collect(field.child);
      }

      if (field?.fixcolumns?.length) {
        collect(field.fixcolumns);
      }

      const inputComponent = field?.inputType?.component;
      const quantityComponent = inputComponent?.sType === "QUANTITY"
        ? inputComponent
        : field?.component;

      if (quantityComponent?.sType !== "QUANTITY") {
        return;
      }

      const quantityPayload =
        field?.inputType?.data?.bPayload == 1 ||
        field?.data?.bPayload == 1 ||
        quantityComponent?.bPayload == 1 ||
        field?.inputtable?.bPayload == 1 ||
        field?.bPayload == 1;

      const quantityField = quantityComponent?.sName;
      const conversionField = quantityComponent?.sConversionName;

      if (quantityField && conversionField && quantityPayload) {
        conversionMap[quantityField] = conversionField;
      }
    });
  };

  collect(fields);
  return conversionMap;
};
